<template>
  <tb-header
      :form-data="formInline"
      @search="onSubmit"
  />
  <!-- 2. 传递数据给内容组件 -->
  <tb-content
      :groupedData="groupedData"
      :summaryData="summaryData"
      :hasDateFilter="hasDateFilter"
  ></tb-content>
</template>
<script lang="ts" setup>

import TbHeader from "@/components/statistic_header/tb_header.vue";
import TbContent from "@/components/statistic_content/tb_content.vue";
import {ref} from "vue";
import {FormInline} from "@/components/statistic_header/tb_header_data";
import {useCheckPage} from "./statistic_page_data";

interface StatisticResult {
  totalAdd: number,
  totalSef: number,
  totalCal: number,
  monthAdd: number,
  monthSef: number,
  motnCal: number,
  dayAdd: number,
  daySef: number,
  dayCal: number,

  htotalAdd: number,
  htotalSef: number,
  htotalCal: number,
  hmonthAdd: number,
  hmonthSef: number,
  hmotnCal: number,
  hdayAdd: number,
  hdaySef: number,
  hdayCal: number,

  htotalCalLV: number,
  monthAddNotHt: number,
  totalCalNotHt: number,
  dayAddNotHt: number,
  daySefNotHt: number,
  monthSefNotHt: number,
  totalSefNotHt: number,
  dayCalNotHt: number,
  totalAddNotHt: number,
  motnCalNotHt: number,
}
interface SummaryData {
  baoFuAdd: number;
  baoFuCal: number;
  baoFuSelf: number;
  bBaoFuAdd: number;
  bBaoFuCal: number;
  bBaoFuSelf: number;
  huiFuAdd: number;
  huiFuSelf: number;
  huiFuCal: number;
}
// 表单数据（由父组件定义，传给子组件）
const formInline = ref<FormInline>({
  "date": ["",""],
});

const defaultTbItem: StatisticResult = {
  totalAdd: 0,
  totalSef: 0,
  totalCal: 0,
  monthAdd: 0,
  monthSef: 0,
  motnCal: 0,
  dayAdd: 0,
  daySef: 0,
  dayCal: 0,

  htotalAdd: 0,
  htotalSef: 0,
  htotalCal: 0,
  hmonthAdd: 0,
  hmonthSef: 0,
  hmotnCal: 0,
  hdayAdd: 0,
  hdaySef: 0,
  hdayCal: 0,

  htotalCalLV: 0,
  monthAddNotHt: 0,
  totalCalNotHt: 0,
  dayAddNotHt: 0,
  daySefNotHt: 0,
  monthSefNotHt: 0,
  totalSefNotHt: 0,
  dayCalNotHt: 0,
  totalAddNotHt: 0,
  motnCalNotHt: 0,
};

// 基础数据（groupedData）- 无日期时更新
const groupedData = ref<StatisticResult>(defaultTbItem)

// 查询数据（summaryData）- 有日期时更新
const summaryData = ref<SummaryData>({
  baoFuAdd: 0,
  baoFuCal: 0,
  baoFuSelf: 0,
  bBaoFuAdd: 0,
  bBaoFuCal: 0,
  bBaoFuSelf: 0,
  huiFuAdd: 0,
  huiFuCal: 0,
  huiFuSelf: 0
})

// 是否有日期过滤
const hasDateFilter = ref(false)

// 2. 使用页面逻辑（支持外部传入状态实现动态变化）
const { onSubmit} = useCheckPage(
    groupedData,
    summaryData,
    hasDateFilter,
    formInline
)


// 初始加载
onSubmit();
</script>
<style scoped>

</style>
